<template>
  <section class="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 mb-swiper">
    <carousel-images
      :slides="slides"
      :secondary-slides="secondarySlides"
      :loading="loadingBanners"
    />
  </section>
  <new-product-section />
  <find-by-brand />
  <home-banner-gallery />
  <flash-offer-section />
  <promotion-gallery />
  <find-by-category />
  <promotion-section />
  <payment-section />
  <save-purchase-section :show-section-small="false" />
  <whats-app-button />
</template>
<script lang="ts">
import { HomeService } from "@/services/HomeService";
import { store } from "~/store";
import {
  VITE_BANNER_CAROUSEL_V2,
  VITE_BANNER_CAROUSEL_SECONDARY,
} from "@/config/constants.js";
import WhatsAppButton from "@/components/common/WhatsAppButton.vue";
import NewProductSection from "@/components/home/NewProductSection.vue";
import FlashOfferSection from "@/components/home/FlashOfferSection.vue";
import FindByBrand from "@/components/home/FindByBrand.vue";
import HomeBannerGallery from "@/components/home/HomeBannerGallery.vue";
import CarouselImages from "@/components/ui/CarouselImages.vue";
import PaymentSection from "@/components/home/PaymentSection.vue";
import SavePurchaseSection from "@/components/home/SavePurchaseSection.vue";
import FindByCategory from "@/components/home/FindByCategory.vue";
import PromotionSection from "@/components/home/PromotionSection.vue";
import PromotionGallery from "@/components/home/PromotionGallery.vue";
import seoService from "@/services/SeoService";

export default {
  components: {
    NewProductSection,
    FlashOfferSection,
    PromotionSection,
    PaymentSection,
    FindByBrand,
    FindByCategory,
    HomeBannerGallery,
    PromotionGallery,
    CarouselImages,
    SavePurchaseSection,
    WhatsAppButton,
  },
  data: function () {
    return {
      slides: [],
      secondarySlides: [],
      loadingBanners: false,
    };
  },
  created() {
    store.commit("setCanCloseMenu", false);
    seoService.setData({
      title: "Todo en Computadoras - Digitalife",
      url: "https://www.digitalife.com.mx/",
      description:
        "Encuentra las mejores ofertas y calidad en tecnología: laptops, tablets, licencias, ensambladas, accesorios gamers y mucho más.",
    });
  },
  mounted() {
    this.loadingBanners = true;
    const homeService = new HomeService();
    homeService.getHomeInitData();
    homeService.getBanners(VITE_BANNER_CAROUSEL_V2).then((response) => {
      if (response) {
        this.slides = response;
      }
    });
    homeService
      .getBanners(VITE_BANNER_CAROUSEL_SECONDARY)
      .then((response) => {
        this.secondarySlides = response;
      })
      .finally(() => {
        this.loadingBanners = false;
      });
  },
};
</script>
<style lang="scss" scoped>
.mb-swiper {
  @media (min-width: 992px) {
    margin-bottom: 80px;
  }
}
</style>
